import React from 'react';
import { useSelector } from 'react-redux';
import PropTypes from 'prop-types';

import { orderReducer } from 'v1/helpers/misc';
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue
} from 'v5/design-system/Select.js';
import { getV5Props } from 'v1/components/shared/byType/text/GetV5Props.js';
import { maybe } from '@passionware/monads';

/**
 * @desc A selector for resource types
 */
const ResourceTypeSelector = ({
  appearance,
  size,
  name,
  value,
  allowNull,
  onChange
}) => {
  const resourceTypes = useSelector(state => state.resource_types);
  const resourceTypesList = orderReducer(resourceTypes).filter(
    t => !t.archived
  );

  return (
    <Select
      appearance={appearance}
      size={size}
      name={name}
      value={maybe.getOrElse(value, '~null')}
      onValueChange={value =>
        value === '~null' ? onChange(null) : onChange(parseInt(value))
      }
      autoComplete="off"
    >
      <SelectTrigger {...getV5Props({ size, appearance })} className="w-auto">
        <SelectValue />
      </SelectTrigger>
      <SelectContent align="end">
        {allowNull && (
          <SelectItem value={'~null'} key={'~null'}>
            {typeof allowNull === 'boolean' ? 'All resource types' : allowNull}
          </SelectItem>
        )}
        {resourceTypesList.map(opt => (
          <SelectItem value={opt.id} key={opt.id}>
            {opt.name}
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
};

ResourceTypeSelector.props = {
  appearance: PropTypes.oneOf(['outline', 'underline', 'silent']),
  size: PropTypes.oneOf(['S', 'M', 'L']),
  name: PropTypes.string.isRequired,
  value: PropTypes.number.isRequired,
  // Set to true if it can be null, eg if you want to select "All"
  // Set to a string for true with a custom label
  allowNull: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  onChange: PropTypes.func.isRequired
};

export default ResourceTypeSelector;
